// AD-2581: a self-service template is offered to self-service forms for the audience chosen on it.
// The values are stored on the template, beside the wizard's own audience values.
const SELF_SERVICE_TEMPLATE_AUDIENCE = {
    parentWithAccount: 2,
    employee: 4,
    employeeLinkedToStudent: 7,
    employeeLinkedToEmployee: 8
};

export const SELF_SERVICE_TEMPLATE_AUDIENCE_LABELS = {
    [SELF_SERVICE_TEMPLATE_AUDIENCE.parentWithAccount]: 'Parent with an Admicity account',
    [SELF_SERVICE_TEMPLATE_AUDIENCE.employee]: 'Employee',
    [SELF_SERVICE_TEMPLATE_AUDIENCE.employeeLinkedToStudent]: 'Employee linked to student',
    [SELF_SERVICE_TEMPLATE_AUDIENCE.employeeLinkedToEmployee]: 'Employee linked to employee'
};

export default SELF_SERVICE_TEMPLATE_AUDIENCE;
